import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6 text-center">
          常见问答
        </h2>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className={`text-lg text-foreground-400 transition-transform duration-300 ${openIdx === idx ? 'ri-subtract-line rotate-180' : 'ri-add-line'}`}></i>
                </span>
              </button>
              <div
                className={`px-5 overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'pb-5 max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}